import { GetSelfResult } from "tech-health-assessment-sdk/dist/modules/self";
import { api } from "../../../../services/core-api-service";

class SelfProviderService {
    public async getSelf(): Promise<GetSelfResult> {
        return api.self.getSelf();
    }
}

export const service = new SelfProviderService()